import { toast } from "react-toastify";
// import { EmployeeServices } from "./EmployeeService";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { successAlert } from "../../Global/GlobalSlice";
import { AccountingSetup } from "./AccountingSetup";
// import { useNavigate } from "react-router";

const initialState = {
  account: "",
};

export const CreateChartofAcct = createAsyncThunk(
  "accountLedgerSetup/CreateCOA",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AccountingSetup.AccountingLedgerSetup().CreateCOA(
        payload
      );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateSubGroup = createAsyncThunk(
  "accountLedgerSetup/CreateSubGroup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await AccountingSetup.AccountingLedgerSetup().CreateSubGroup(payload);

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const CreateAccount = createAsyncThunk(
  "accountLedgerSetup/CreateAccount",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AccountingSetup.AccountingLedgerSetup().CreateAcct(
        payload
      );

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllAccount = createAsyncThunk(
  "accountLedgerSetup/GetAllAcct",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await AccountingSetup.AccountingLedgerSetup().GetAllAcct(
        payload
      );
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetAllTransAccount = createAsyncThunk(
  "accountLedger/GetAllTransAcct",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await AccountingSetup.AccountingLedgerSetup().GetAllTransAcct(payload);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);


export const GetAllCreditFacility = createAsyncThunk(
  "CreditFacility/all",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await AccountingSetup.AccountingLedgerSetup().GetAllCredit(payload);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const GetCreditFacility = createAsyncThunk(
  "CreditFacility",
  async (id, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await AccountingSetup.AccountingLedgerSetup().GetCredit(id);
      // toast.success(response?.data?.statusMessage);
      return response?.data;
    } catch (error) {
      // toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const PostReverseFT = createAsyncThunk(
  "accountLedgerSetup/PostReverse",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await AccountingSetup.AccountingLedgerSetup().PostReverse(payload);

      if (response?.data?.successful === true) {
        // const { id } = payload;
        // toast.success(response?.data?.statusMessage);
        toast.success(`Record was sent successfully for review`);
        // dispatch(
        //   successAlert({
        //     message: response?.data?.statusMessage,
        //   })
        // );
      }

      if (response?.data?.successful === false) {
        toast.error(response?.data?.statusMessage);
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const ApproveReverseFT = createAsyncThunk(
  "accountLedgerSetup/ApproveReverse",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await AccountingSetup.AccountingLedgerSetup().ApproveReverse(payload);

      if (response?.data?.successful === true) {
        // const { id } = payload;
        // toast.success(response?.data?.statusMessage);
        toast.success(`Reverse approval was successfully`);
        // dispatch(
        //   successAlert({
        //     message: response?.data?.statusMessage,
        //   })
        // );
      }

      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const DeclineReverseFT = createAsyncThunk(
  "accountLedgerSetup/DeclineReverse",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await AccountingSetup.AccountingLedgerSetup().ApproveReverse(payload);

      if (response?.data?.successful === true) {
        // const { id } = payload;
        // toast.success(response?.data?.statusMessage);
        toast.info(`Reverse was declined`);
        // dispatch(
        //   successAlert({
        //     message: response?.data?.statusMessage,
        //   })
        // );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateGroupAcct = createAsyncThunk(
  "accountLedgerSetup/UpdateGroup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await AccountingSetup.AccountingLedgerSetup().UpdateGroup(payload);

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const UpdateSubGroupAcct = createAsyncThunk(
  "accountLedgerSetup/UpdateSubgroup",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response =
        await AccountingSetup.AccountingLedgerSetup().UpdateSubgroup(payload);

      if (response?.data?.successful === true) {
        dispatch(
          successAlert({
            message: response?.data?.statusMessage,
          })
        );
      }
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage);
      console.log(error);
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const AccountSetupSlice = createSlice({
  name: "accountLedgerSetup",
  initialState,

  extraReducers: (builder) => {
    //   Create COA
    builder.addCase(CreateChartofAcct.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(CreateChartofAcct.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(CreateChartofAcct.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    //   Create SubGroup
    builder.addCase(CreateSubGroup.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(CreateSubGroup.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(CreateSubGroup.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    //   Create Account
    builder.addCase(CreateAccount.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(CreateAccount.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(CreateAccount.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    // GetAllAccount
    builder.addCase(GetAllAccount.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllAccount.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        allAcctData: action.payload,
      };
    });
    builder.addCase(GetAllAccount.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });

    // Get All Finance Transaction
    builder.addCase(GetAllTransAccount.pending, (state) => {
      return {
        ...state,
        isLoading: true,
      };
    });
    builder.addCase(GetAllTransAccount.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        allTransData: action.payload,
      };
    });
    builder.addCase(GetAllTransAccount.rejected, (state, action) => {
      return {
        ...state,
        isLoading: false,
        error: action.error.message,
      };
    });

    //   Handle Post Reverse
    builder.addCase(PostReverseFT.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(PostReverseFT.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(PostReverseFT.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    //   Handle Approve Reverse
    builder.addCase(ApproveReverseFT.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(ApproveReverseFT.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(ApproveReverseFT.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    //   Handle Decline Reverse
    builder.addCase(DeclineReverseFT.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(DeclineReverseFT.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(DeclineReverseFT.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    //   Update Group
    builder.addCase(UpdateGroupAcct.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(UpdateGroupAcct.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(UpdateGroupAcct.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });

    //   Update SubGroup
    builder.addCase(UpdateSubGroupAcct.pending, (state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    builder.addCase(UpdateSubGroupAcct.fulfilled, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        isSuccessful: true,
        creationData: action.payload,
      };
    });
    builder.addCase(UpdateSubGroupAcct.rejected, (state, action) => {
      return {
        ...state,
        isSubmitting: false,
        error: action.error.message,
      };
    });
  },
});

export default AccountSetupSlice.reducer;
